import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '@/pages/Login/IndexView.vue'

import { isAuthenticated } from './guard'
import userRoutes from './userRoutes'
import shareRoutes from './shareRoutes'
import maestroRoutes from "@/router/maestroRoutes";
import setLayout from './setLayout'

// Экраны грузятся отдельными чанками: иначе первый запрос тянет весь код
// приложения (chart.js, cropper, редакторы) и держит его в памяти вкладки.
// Login оставлен статическим — это первый экран неавторизованного входа.


const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ "@/pages/Dashboard/IndexView.vue"),
    meta: { auth: true, authorize: "manager" }
  },
  {
    path: '/schedule/:id',
    name: 'Schedule',
    component: () => import(/* webpackChunkName: "schedule" */ "@/pages/Schedule/IndexView.vue"),
    meta: { auth: true, authorize: "manager" }
  },
  {
    path: '/schedule-groups',
    name: 'ScheduleGroups',
    component: () => import(/* webpackChunkName: "schedulegroups" */ "@/pages/ScheduleGroups/IndexView.vue"),
    meta: { auth: true, authorize: "manager" }
  },
  {
    path: '/schedule-groups/:id',
    name: 'ScheduleGroup',
    component: () => import(/* webpackChunkName: "schedulegroup" */ "@/pages/ScheduleGroup/IndexView.vue"),
    meta: { auth: true, authorize: "manager" }
  },
  {
    path: '/schedules/:id/events',
    name: 'ScheduleEvents',
    component: () => import(/* webpackChunkName: "scheduleevents" */ "@/pages/Schedule/Events/IndexView.vue"),
    meta: { auth: true, feature: "events" }
  },
  {
    path: '/all-schedules',
    name: 'AllSchedules',
    component: () => import(/* webpackChunkName: "allschedules" */ "@/pages/AllSchedules/IndexView.vue"),
    meta: { auth: true }
  },
  {
    path: '/registration/:id',
    name: 'Registration',
    component: () => import(/* webpackChunkName: "registration" */ "@/pages/Registration/IndexView.vue"),
    meta: { auth: false, layout: 'Simple' }
  },
  {
    path: '/statistics',
    name: 'Statistics',
    component: () => import(/* webpackChunkName: "statistics" */ "@/pages/Statistics/IndexView.vue"),
    meta: { auth: true, authorize: "manager" }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import(/* webpackChunkName: "settings" */ "@/pages/Settings/IndexView.vue"),
    meta: { auth: true, authorize: "manager" }
  },
  {
    path: '/events',
    name: "Events",
    component: () => import(/* webpackChunkName: "events" */ "@/pages/Events/IndexView.vue"),
    meta: { auth: true, feature: "events" }
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: { auth: false, layout: 'Simple' }
  },
  {
    path: '/organization-register',
    name: 'OrganizationRegister',
    component: () => import(/* webpackChunkName: "organizationregister" */ "@/pages/OrganizationRegister/IndexView.vue"),
    meta: { auth: false, layout: 'Simple' }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import(/* webpackChunkName: "forgotpassword" */ "@/pages/ForgotPassword/IndexView.vue"),
    meta: { auth: false, layout: 'Simple' }
  },
  {
    path: '/reset-password/:token',
    name: 'ResetPassword',
    component: () => import(/* webpackChunkName: "resetpassword" */ "@/pages/ResetPassword/IndexView.vue"),
    meta: { auth: false, layout: 'Simple' }
  },
  ...userRoutes,
  ...shareRoutes,
  ...maestroRoutes,
  {
    path: "/tutorial",
    name: "Tutorial",
    component: () => import(/* webpackChunkName: "tutorial" */ "@/pages/Tutorial/IndexView.vue"),
    meta: { auth: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(isAuthenticated)

router.afterEach((to, from) => {
  setLayout(to)
})

export default router
